import { render, staticRenderFns } from "./FolderAdd.vue?vue&type=template&id=6f56a972&scoped=true"
import script from "./FolderAdd.vue?vue&type=script&lang=js"
export * from "./FolderAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f56a972",
  null
  
)

export default component.exports